module.exports = __webpack_public_path__ + "img/no_data.e7a0bfdd.png";